export const locale = {
    'STEP_CUSTOMER_ORDER': {
        'DIALOG': {
            'AGREE_FIELD': {
                'TITLE': 'Статус заказа',
                'AGREE': 'Согласован',
                'NOT_AGREE': 'Не согласован',
            },
        },
    },
};
